import { Injectable } from '@angular/core';
import { BsDatepickerConfig } from './bs-datepicker.config';
export class BsDatepickerInlineConfig extends BsDatepickerConfig {
}
BsDatepickerInlineConfig.decorators = [
    { type: Injectable },
];
//# sourceMappingURL=bs-datepicker-inline.config.js.map